
import styled from 'styled-components';

const StyledSliderContainer = styled.div`
  width: 100%;
  margin: 8px 0;
  box-sizing: border-box;
`;

export { StyledSliderContainer };
